import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=784d58a4&scoped=true&lang=pug"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"
import style0 from "./Hero.vue?vue&type=style&index=0&id=784d58a4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784d58a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('784d58a4')) {
      api.createRecord('784d58a4', component.options)
    } else {
      api.reload('784d58a4', component.options)
    }
    module.hot.accept("./Hero.vue?vue&type=template&id=784d58a4&scoped=true&lang=pug", function () {
      api.rerender('784d58a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/Hero.vue"
export default component.exports